import AutoAbstractField from "./AutoAbstractField.mjs";
import autoFormHelper from "../helperLibs/autoFormHelper.mjs";
import AutoFormFields from "../AutoFormFields.mjs";
import G from "../../libs/Glob.mjs";

const AutoGroupField = class extends AutoAbstractField {
	constructor(props) {
		super(props);
		this.state.localHelper = new autoFormHelper({
			parent: this.state.fh,
			fields: G.clone(props.def.fields||[] ),
			data: this.state.value || {}
		});
	}
	renderField() {
		return(
			<blockquote>
				<AutoFormFields
					fields={ this.props.def.fields }
					helper={ this.state.localHelper }
					topHelper={ this.props.topHelper }
					data={ this.state.value || {} }
				/>
			</blockquote>
		)
	}
}

export default AutoGroupField;